import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HarloweSupport } from '@harlowe/core';
import { FileUploadModule } from 'primeng/fileupload';

@Component({
  selector: 'app-file-editor',
  standalone: true,
  imports: [FileUploadModule],
  templateUrl: './file-editor.component.html',
  styleUrl: './file-editor.component.scss'
})
export class FileEditorComponent 
{
  @Input() file?: HarloweSupport.File;
  @Output() saved: EventEmitter<HarloweSupport.File> = new EventEmitter<HarloweSupport.File>();
  @Output() cancelled = new EventEmitter();

}
